module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("添加版本")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "版本名称",
      "size": "mini"
    },
    model: {
      value: (_vm.params.version_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "version_name", $$v)
      },
      expression: "params.version_name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchData
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.versionList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version_name",
      "label": "版本名",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', [_vm._v(_vm._s(scope.row.version_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version_num",
      "label": "版本号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "downloads",
      "label": "下载地址",
      "width": "450"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "release_time",
      "label": "发布时间",
      "width": "160",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("datetime")(scope.row.release_time, 'yyyy-MM-dd hh:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_save",
      "align": "center",
      "label": "使用这个版本更新?",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-value": "1",
            "inactive-value": "0",
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.switchAuth(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.is_save),
            callback: function($$v) {
              _vm.$set(scope.row, "is_save", $$v)
            },
            expression: "scope.row.is_save"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.page_size) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.page_size
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加、编辑版本",
      "width": "40%",
      "visible": _vm.memberTagDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "下载地址",
        "prop": "downloads",
        "rules": [{
          required: true,
          message: '请输入下载地址',
          trigger: 'blur'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入下载地址名称"
      },
      model: {
        value: (_vm.form.downloads),
        callback: function($$v) {
          _vm.$set(_vm.form, "downloads", $$v)
        },
        expression: "form.downloads"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "版本名称",
        "prop": "version_name",
        "rules": [{
          required: true,
          message: '请输入版本名称',
          trigger: 'blur'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入标签名称"
      },
      model: {
        value: (_vm.form.version_name),
        callback: function($$v) {
          _vm.$set(_vm.form, "version_name", $$v)
        },
        expression: "form.version_name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "版本号",
        "prop": "version_num",
        "rules": [{
          required: true,
          message: '请输入版本名称',
          trigger: 'blur'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入标签名称"
      },
      model: {
        value: (_vm.form.version_num),
        callback: function($$v) {
          _vm.$set(_vm.form, "version_num", $$v)
        },
        expression: "form.version_num"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "版本说明"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "rows": 3,
        "placeholder": "请输入版本说明"
      },
      model: {
        value: (_vm.form.descvs),
        callback: function($$v) {
          _vm.$set(_vm.form, "descvs", $$v)
        },
        expression: "form.descvs"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "发布时间"
      }
    }, [_c('el-date-picker', {
      attrs: {
        "type": "datetime",
        "value-format": "yyyy-MM-dd HH:mm",
        "default-time": "00:00:00",
        "picker-options": _vm.pickerOptions
      },
      model: {
        value: (_vm.form.release_time),
        callback: function($$v) {
          _vm.$set(_vm.form, "release_time", $$v)
        },
        expression: "form.release_time"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.updateVsersionData
      }
    }, [_vm._v("确定保存")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d301542", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d301542"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/app/version.vue
// module id = 2459
// module chunks = 0